import React from "react"
import { Routes, Route, Navigate } from "react-router-dom"
import useTranslations from "../hooks/useTranslations.js"
import useShop from "../hooks/useShop.js"
import Onboarding from "./Onboarding.jsx"
import DashboardShell from "./dashboard/DashboardShell.jsx"
import Overview from "./dashboard/Overview.jsx"
import ExperimentsPage from "./dashboard/ExperimentsPage.jsx"
import ExperimentDetailPage from "./dashboard/ExperimentDetailPage.jsx"
import ProposalsPage from "./dashboard/ProposalsPage.jsx"
import SettingsPage from "./dashboard/SettingsPage.jsx"
import ScriptPage from "./dashboard/ScriptPage.jsx"
import FunnelPage from "./dashboard/FunnelPage.jsx"
import ProfilePage from "./dashboard/ProfilePage.jsx"

export default function App({ translations }) {
  const t = useTranslations(translations)
  const shopState = useShop()

  // Onboarding owns the UI until the shop is "active" AND the snippet has
  // either phoned home OR the user has explicitly skipped on this device.
  // Skip is a per-device UX preference (localStorage), not business state —
  // the dashboard's missing-script indicator still drives the user back to
  // the Script page after skip.
  const shop = shopState.shop
  const skipped = typeof window !== "undefined" &&
                  window.localStorage.getItem("shopshift_skip_install") === "1"
  const needsInstall = shop && shop.status === "active" &&
                       !shop.script_installed && !skipped
  const inOnboarding = shopState.status !== "loaded" || !shop ||
                       shop.status !== "active" || needsInstall

  if (inOnboarding) {
    return <Onboarding t={t} shopState={shopState} />
  }

  return (
    <Routes>
      <Route element={<DashboardShell t={t} shopState={shopState} />}>
        <Route path="/" element={<Overview t={t} shopState={shopState} />} />
        <Route path="/experiments" element={<ExperimentsPage t={t} />} />
        <Route path="/experiments/:id" element={<ExperimentDetailPage t={t} />} />
        <Route path="/proposals" element={<ProposalsPage t={t} />} />
        <Route path="/settings" element={<SettingsPage t={t} shopState={shopState} />} />
        <Route path="/script" element={<ScriptPage t={t} shopState={shopState} />} />
        <Route path="/funnel" element={<FunnelPage t={t} />} />
        <Route path="/profile" element={<ProfilePage t={t} />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}
